import * as React from "react";
import { forwardRef } from "react";
const SvgWarning = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 13, viewBox: "0 0 16 13", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M0.666992 12.9997H15.3337L8.00033 0.333008L0.666992 12.9997ZM8.66699 10.9997H7.33366V9.66634H8.66699V10.9997ZM8.66699 8.33301H7.33366V5.66634H8.66699V8.33301Z", fill: "#96A2AC" }));
const ForwardRef = forwardRef(SvgWarning);
export default ForwardRef;
